import type { Template } from "@/types";

export const SQ_06_H2_V4: Template[] = [
    {
        id: "sq-06-h2v4-01",
        name: "SQ 01 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 142, width: 272, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 349, y: 142, width: 299, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 349, y: 362, width: 299, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 786, y: 76, width: 382, height: 565, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1176, y: 76, width: 189, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1176, y: 363, width: 189, height: 278, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-02",
        name: "SQ 02 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 164, y: 76, width: 389, height: 565, rotation: 0, imageRotation: 0 },
            { id: "2", x: 786, y: 76, width: 446, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 786, y: 363, width: 446, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1240, y: 76, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1240, y: 267, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1240, y: 458, width: 125, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-03",
        name: "SQ 03 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 142, width: 272, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 349, y: 142, width: 299, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 349, y: 362, width: 299, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 853, y: 142, width: 292, height: 433, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1153, y: 142, width: 145, height: 213, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1153, y: 363, width: 145, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-04",
        name: "SQ 04 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 126, y: 49, width: 465, height: 306, rotation: 0, imageRotation: 0 },
            { id: "2", x: 126, y: 363, width: 465, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 863, y: 49, width: 209, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 863, y: 363, width: 209, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 49, width: 208, height: 306, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 363, width: 208, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-05",
        name: "SQ 05 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 42, y: 174, width: 544, height: 369, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 594, y: 174, width: 119, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 594, y: 363, width: 119, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 174, width: 119, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 363, width: 119, height: 180, rotation: 0, imageRotation: 0 },
            { id: "6", x: 848, y: 174, width: 544, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-06",
        name: "SQ 06 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 163, width: 578, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 586, y: 163, width: 127, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 586, y: 363, width: 127, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 163, width: 578, height: 391, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1307, y: 163, width: 127, height: 192, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1307, y: 363, width: 127, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-07",
        name: "SQ 07 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 163, width: 578, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 586, y: 163, width: 127, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 721, y: 163, width: 127, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 586, y: 363, width: 127, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 363, width: 127, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 856, y: 163, width: 578, height: 391, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h2v4-08",
        name: "SQ 08 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 71, y: 70, width: 574, height: 365, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 443, width: 138, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 443, width: 138, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 443, width: 137, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 508, y: 443, width: 137, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 786, y: 163, width: 579, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-09",
        name: "SQ 09 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 71, y: 70, width: 187, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 362, width: 187, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 266, y: 362, width: 186, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 460, y: 362, width: 186, height: 284, rotation: 0, imageRotation: 0 },
            { id: "5", x: 266, y: 70, width: 380, height: 284, rotation: 0, imageRotation: 0 },
            { id: "6", x: 786, y: 163, width: 579, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h2v4-10",
        name: "SQ 10 - H2V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h2_v4_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 71, y: 70, width: 304, height: 576, rotation: 0, imageRotation: 0 },
            { id: "2", x: 383, y: 70, width: 263, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 252, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "4", x: 883, y: 70, width: 385, height: 270, rotation: 0, imageRotation: 0 },
            { id: "5", x: 883, y: 348, width: 189, height: 298, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 348, width: 188, height: 298, rotation: 0, imageRotation: 0 }
        ],
    },
];

